import toast from 'react-hot-toast'

export function notify (message, isError) {
  if (isError) {
    toast.error(message, {
      position: 'bottom-center',
      duration: 5000
    })
  } else {
    toast(message, {
      position: 'bottom-center',
      duration: 5000
    })
  }

  // Hack to don't rewrite function calls
  // ToDo: rewrite all function calls
  return () => ({})
}
